define.alias("ember-composable-helpers/helpers/object-at", "settings/helpers/object-at");